import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';

export interface CampaignDetailsDTO {
  clientId: number;
  completionDate: string | null;
  email: string;
  engagementDate: string;
  firstEngagement: boolean;
  income: number;
  name: string;
  phoneNumber: string | null;
  speakWithAdvisor: boolean;
  totalAssets: number;
  isDeleted?: boolean;
}

interface FetchCampaignDetailsParams {
  campaignId?: string;
}

const fetchCampaignDetails = async ({
  campaignId,
}: FetchCampaignDetailsParams): Promise<CampaignDetailsDTO[]> => {
  return authFetch(`/Adviser/Campaigns/Details/${campaignId}`);
};

interface UseCampaignDetailsQueryParams {
  campaignId?: string;
}

export const useCampaignDetailsQuery = ({ campaignId }: UseCampaignDetailsQueryParams) =>
  useQuery(queryKeys.campaignDetails(campaignId), () => fetchCampaignDetails({ campaignId }));
